/**
* Initializes the site's awardeeSlider component.
* @constructor
* @param {Object} el - The site's awardeeSlider container element.
*/

import Glide from '@glidejs/glide/dist/glide.esm'

const awardeeSlider = el => {
    const prev = el.querySelector('.arrow--prev')
    const next = el.querySelector('.arrow--next')
    console.log(prev, next)
    const dots = el.querySelectorAll('.dots__dot')
    const slider = new Glide(el.querySelector('.glide'),{
        // startAt: 0,
        type: 'carousel',
        perView: 1,
    })

    slider.on('run.after', evt => {
        const index = el.querySelector('.glide__slide--active').dataset.slide
        dots.forEach(d => {
            d.dataset.slide == index ? d.classList.add('active') : d.classList.remove('active')
        })
    })
    slider.mount()

    prev.addEventListener('click', () => slider.go('<'))
    next.addEventListener('click', () => slider.go('>'))

    dots.forEach(dot => {
        dot.addEventListener('click', evt => {
            slider.go(`=${dot.dataset.slide}`)
            dots.forEach(d => d.classList.remove('active'))
            dot.classList.add('active')
        })
    })
}
export default function(el) {
    awardeeSlider(el)
}
